import { Box, Title } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import { ContactFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import ContactInfo from 'modules/finance/components/Contacts/ContactInfo'
import { FinanceContactsSelector } from 'modules/finance/components/Contacts/FinanceContactsSelector'
import type { InvoiceType } from 'modules/finance/components/Invoices/Detail/Content/Form/types'
import { InvoiceForm } from 'modules/finance/components/Invoices/Detail/Content/Form/types'

interface TaxesSectionProps {
  form: FormikProps<InvoiceForm>
  invoice: InvoiceType
  readOnly: boolean
}

export const VendorSection: React.FC<TaxesSectionProps> = ({ form, invoice, readOnly }) => {
  const handleVendorSelect = (vendor: ContactFragment | null) => {
    form.setValues({ ...form.values, vendor })
  }

  return (
    <Box gap="s8" paddingTop="s8">
      <Title variant="400" title={i18n.t('finance.invoices.detail.fields.vendor_information')} />
      <FinanceContactsSelector
        mandatory
        disabled={readOnly}
        value={form.values.vendor}
        onSelect={handleVendorSelect}
        label={i18n.t('finance.vendors.vendor_legal_name')}
        type="finance_contact"
        queryParams={{
          companyId: invoice.companyId,
          contactCreateType: 'vendor',
        }}
        error={form.errors.vendor}
        hideSearchIcon
        variant={'gamma'}
      />
      {form.values.vendor && (
        <ContactInfo
          showTitle={false}
          contact={form.values.vendor}
          showLinkToEdit={false}
          as={'vendor'}
        />
      )}
    </Box>
  )
}
